import React from "react";
import going from "../../assets/get_to_know_us/going.svg";
import mission from "../../assets/get_to_know_us/mission.svg";
import perspective from "../../assets/get_to_know_us/perspective.svg";
import goingline from "../../assets/get_to_know_us/goingLine.svg";
import perspectiveLine from "../../assets/get_to_know_us/perspectiveLine.svg";
import missionLine from "../../assets/get_to_know_us/missionLine.svg";
import goingsideLine from "../../assets/get_to_know_us/goingContentLine.svg";
import missionsideLine from "../../assets/get_to_know_us/missionContentLine.svg";
import perspectivesideLine from "../../assets/get_to_know_us/perspecticeContentLine.svg";
import "./style.scss";

export default function GetToKnow() {
  return (
    <>
      <div className="gtks_header" id="get-to-know-us">
        <span></span>
        <p>Get To Know Us!</p>
        <span></span>
      </div>

      <div className="main-div">
        <div className="mission">
          <div className="ourMission">
            <h1 className="subheading">Our Mission</h1>
            <img src={missionLine} alt="" />
          </div>

          <div className="missionbody">
            <img src={mission} alt=" " className="bigImg-mission missionImg" />
            <div className="content">
              Our mission involves community engagement, leadership development, building strong
              tech foundation, while enabling all tech enthusiasts to contribute to the global
              society. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum, laboriosam
              cum similique ducimus architecto eos.
            </div>
            <img className="sideline" src={missionsideLine} alt="" />
          </div>
        </div>

        <div className="perspective-section">
          <div className="perspectivepart">
            <h1 className="subheading">Our Perspective</h1>
            <img src={perspectiveLine} alt="" />
          </div>
          <div className="perspectivebody">
            <img className="sideline" src={perspectivesideLine} alt="" />
            <div className="content">
              We’re a community-driven initiative aiming to bridge the gap between research and
              practice , develop evolutionary thinking and network throughout the process. We
              believe in connecting fellow developers , spreading stimulative ideas and working for
              a solution driven team.
            </div>
            <img src={perspective} alt=" " className="bigImg perspectiveImg" />
          </div>
        </div>

        <div className="going">
          <div className="going-section">
            <h1 className="subheading">What Keeps Us Going?</h1>
            <img src={goingline} alt=" " style={{ textAlign: "center" }} />
          </div>
          <div className="goingbody">
            <img src={going} alt=" " className="bigImg" />
            <div className="content">
              Our club helps students to connect, learn, empower and grow. Teamwork, innovative
              thinking, communication, and leading with solutions is what helps us achieve new
              heights. The entire team works in coordination, to inspire and motivate the upcoming
              coding community to evolve their skills and broaden their horizons of knowledge.
            </div>
            <img className="sideline" src={goingsideLine} alt="" />
          </div>
        </div>
      </div>
    </>
  );
}
